import { useReducer } from 'react';
import Home from 'renderer/pages/Home/Home';
import { reducer } from './State/Reducer';
import loadGlobalData from './State/InitData/loadGlobalData';

export default function Global() {
  const [state, dispatch] = useReducer(reducer, loadGlobalData());

  return <Home state={state} dispatch={dispatch} />;
}
